// src/utils/consentGating.js
/**
 * This file ensures:
 * - No non-essential scripts load before consent
 * - Analytics loads only after consent.analytics === true
 * - Marketing loads only after consent.marketing === true
 *
 * Works for SPA route changes too (because scripts live globally).
 */

// ---- CONFIG ----
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_ID || "";
// If you use CRA, set REACT_APP_GA_ID in .env

// Track whether we already injected scripts
let gaLoaded = false;

/** Inject a script only once */
function loadScriptOnce(id, src) {
  if (!src) return;
  if (document.getElementById(id)) return;

  const s = document.createElement("script");
  s.id = id;
  s.async = true;
  s.src = src;
  document.head.appendChild(s);
}

function enableGoogleAnalytics() {
  if (!GA_MEASUREMENT_ID) {
    console.warn("GA Measurement ID not set. Skipping GA load.");
    return;
  }
  if (gaLoaded) return;

  // 1) Load gtag script
  loadScriptOnce("ga-gtag", `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`);

  // 2) Init gtag
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = window.gtag || gtag;

  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID, {
    anonymize_ip: true, // good practice
  });

  gaLoaded = true;
}

function disableGoogleAnalytics() {
  // You can't fully "unload" GA reliably, but you can stop sending data.
  // This is acceptable and common: turn off tracking + set consent mode.
  if (window.gtag && GA_MEASUREMENT_ID) {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
    });
  }
}

// Optional: Google Consent Mode (recommended if you use Google tags)
// If you want it, we can add full consent-mode wiring.

export function applyConsent(consent) {
  // Analytics gating
  if (consent?.analytics) {
    enableGoogleAnalytics();
    if (window.gtag) {
      window.gtag("consent", "update", { analytics_storage: "granted" });
    }
  } else {
    disableGoogleAnalytics();
  }

  // Marketing gating placeholder
  // If you add Meta Pixel / LinkedIn etc, load them ONLY when consent.marketing === true.
  // Example later if you tell me which marketing scripts you use.
}
